export const PRIVACY_POLICY_VALIDATION = {
    title: {
        required: 'Title wajib diisi',
    },
    description: {
        required: 'Description wajib diisi',
    },
}
